var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length > 0)?_c('p',{class:[("text-" + _vm.color), { 'font-weight-bold': _vm.bold }]},[_vm._v(" "+_vm._s(_vm.errors[0])+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }